import { render, staticRenderFns } from "./Entrypoints.vue?vue&type=template&id=53c9bd1c&scoped=true"
import script from "./Entrypoints.vue?vue&type=script&lang=js"
export * from "./Entrypoints.vue?vue&type=script&lang=js"
import style0 from "./Entrypoints.vue?vue&type=style&index=0&id=53c9bd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9bd1c",
  null
  
)

export default component.exports